import $ from "jquery";
// import Swiper bundle with all modules installed
// import Swiper, { Navigation, Pagination } from 'swiper';
import "slick-carousel";

const sliderDivider = () => {
  const el = {
    container: ".PhotoSliderSection",
    sliderEl: ".PhotoSliderSection .js-PhotoSlider",
  };

  if ($(el.container).length === 0) return;

  $(el.sliderEl).slick({
    dots: false,
    prevArrow: false,
    nextArrow: false,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

};

try {
  sliderDivider();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error("Error:", error);
}
